import React, { FC } from 'react'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import CustomFormCostCenterSelectionDrawerManagerContent from './Content'
import CustomFormCostCenterSelectionDrawerManagerProvider from './contexts/CustomFormCostCenterSelectionDrawerManager/Provider'

type Props = {
  question: CustomFormQuestion
  questionKey: string
  disabled?: boolean
}

const CustomFormCostCenterSelectionDrawer: FC<Props> = ({ question, questionKey, disabled }) => {
  return (
    <CustomFormCostCenterSelectionDrawerManagerProvider questionKey={questionKey}>
      <CustomFormCostCenterSelectionDrawerManagerContent question={question} disabled={disabled} />
    </CustomFormCostCenterSelectionDrawerManagerProvider>
  )
}

export default CustomFormCostCenterSelectionDrawer
